<template>
    <v-card class="action-card" :class="bg">
        <div class="card-content text-center">
            <img
                v-if="icon === 'card1'"
                class="card1-image1"
                src="../../assets/icons/card1_img1.png"
                alt="chest"
            />
            <img
                v-if="icon === 'card2'"
                class="card2-image1"
                src="../../assets/icons/card2_img1.png"
                alt="nexon card"
            />
            <v-card-title
                v-text="title"
                class="card-title justify-center"
            ></v-card-title>
            <v-card-text class="card-text text-md-center">{{
                description
            }}</v-card-text>
            <v-btn
                class="card-btn"
                :to="to"
                depressed
                rounded
                :ripple="false"
                :data-ga="dataGa"
                >{{ buttonText }}</v-btn
            >
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'action-card',
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        buttonText: {
            type: String,
            required: true,
        },
        to: {
            type: String,
            required: true,
        },
        bg: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        dataGa: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
.action-card {
    position: relative;
    width: 100%;
    max-width: 424px;
    height: 384px;
    overflow: hidden;
    border-radius: 10px;
    .card-content {
        height: 100%;
        color: white;
        .card1-image1,
        .card2-image1 {
            position: absolute;
            right: 5%;
            bottom: 80px;
            width: 90%;
        }
        .card-title {
            word-break: initial;
            font-family: KlavikaNX-Regular, serif;
            padding: 15px 0;
            margin-bottom: 10px;
            text-transform: uppercase;
            font-size: 30px;
            font-weight: bold;
            line-height: normal;
            position: relative;
            background-image: url('../../assets/icons/front-page-box-divider.png');
            background-position: bottom;
        }
        .card-text {
            font-size: 18px;
            line-height: 1.5;
            position: relative;
            padding: 0 40px;
        }
        .card-btn {
            font-size: 14px;
            letter-spacing: normal;
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translate(-50%, 0%);
            font-weight: 900;
        }
    }
    .v-btn {
        color: #2960e8;
        width: 180px;
        height: 54px;
        background-color: #ffffff;
        font-weight: bold;
        &:hover:before,
        &:focus:before {
            color: transparent;
            transition: none;
        }
        &:before {
            transition: none;
        }
        &:hover {
            box-shadow: 0 10px 15px 0 #2960e8 !important;
        }
        &:focus {
            box-shadow: none !important;
            opacity: 0.8;
        }
    }
    &.pink-gradient {
        background-image: linear-gradient(to bottom, #2960e8, #5776cf);
        box-shadow: 0 40px 60px -30px #2960e8;
        @include break('sm') {
            box-shadow: 0 40px 60px -50px #2960e8;
        }
    }
    &.blue-gradient {
        position: relative;
        left: -20px;
        background-image: linear-gradient(to bottom, #1d1e50, #37395b);
        box-shadow: 0 40px 60px -36px #1d1e50;
        @include break('sm') {
            box-shadow: 0 40px 60px -50px #1d1e50;
        }

        .v-btn {
            &:hover {
                box-shadow: 0 10px 15px 0 #1d1e50 !important;
            }
        }

        .card-text {
            text-align: justify !important;
        }
    }
}

@media (max-width: 907px) {
    .action-card {
        .card-content {
            .card1-image1,
            .card2-image1 {
                right: 25%;
                bottom: 70px;
                width: 50%;
            }
            .card-btn {
                bottom: 10px;
            }

            .card-title {
                background-size: 100% 13%;
            }
        }
        &.blue-gradient {
            left: 0;
        }
    }
}

@include break('md') {
    .action-card {
        .card-content {
            display: block;
            .card-title {
                font-size: 32px;
            }
        }
    }
}
@include break('xl') {
    .action-card {
        width: 530px;
        height: 480px;
        max-width: 530px;
        .card-content {
            .card-title {
                padding: 30px 0 20px 0;
                font-size: 40px;
            }
            .card-text {
                font-size: 22px;
            }
        }
    }
}
</style>
